import { type ReactNode, createContext, useContext } from 'react';

const ResourceSectionReadOnlyContext = createContext(false);

export function useResourceSectionReadOnly(): boolean {
  return useContext(ResourceSectionReadOnlyContext);
}

export function ResourceSectionReadOnlyProvider({ readOnly, children }: { readOnly: boolean; children: ReactNode }) {
  return <ResourceSectionReadOnlyContext.Provider value={readOnly}>{children}</ResourceSectionReadOnlyContext.Provider>;
}

/**
 * @deprecated 下单字段/操作锁改由 resolveOrderAccessPolicy 按字段自身有值判定，不再整块 fieldset 禁用。
 * 保留导出供调用方兼容，恒为 false。
 */
export function isOrderModuleReadOnly(_options: {
  resourceEditMode?: string;
  deployTypeCode?: string;
  moduleKey: string;
  presetConfigSnapshot?: Record<string, unknown>;
}): boolean {
  return false;
}

export interface ResourceModuleReadOnlyGuardProps {
  moduleKey: string;
  children: ReactNode;
}

/** 兼容壳：不再套 fieldset；只读由 fieldModes / isOrderPresetFieldLocked 负责 */
export function ResourceModuleReadOnlyGuard({ children }: ResourceModuleReadOnlyGuardProps) {
  return <>{children}</>;
}
